import React from 'react'
import { faChevronDown, faChevronUp } from '@fortawesome/free-solid-svg-icons'
import { del, post } from 'client/utils/api-routes.util'
import {
  $DCprimaryColor,
  DcButton,
  PixelCollapse,
  PixelCreditCards,
  PixelDiv,
  PixelFactoryContext,
  PixelFlexBox,
  PixelIcon,
  PixelModal,
  Section,
  SectionTitle,
} from 'pixel-base'

import { IPixelFactory } from '../../../../../../../decl'
import AddNewPaymentMethod from '../../../../../customers/pages/details/components/components/AddNewPaymentMethod'
import PaymentMethod from '../components/PaymentMethod'

const CollapsedPaymentOption = (props) => {
  const { data, item, method_type } = props
  const {
    showPageLoader,
    hidePageLoader,
    hideLoader,
    pixelConfirm,
    showSuccess,
    showFailure,
  } = React.useContext<IPixelFactory>(PixelFactoryContext)
  const [paymentMethods, setPaymentMethods] = React.useState<any>([])
  const [isExpanded, setExpanded] = React.useState(false)

  const [showModal, setShowModal] = React.useState(false)

  let cardPayment = paymentMethods?.filter(
    (method) => method.method_type === 'card',
  )
  const bankPayment = paymentMethods?.filter(
    (method) => method.method_type === 'bank',
  )
  const setNewData = (data) => {
    const newData = data
    setPaymentMethods([...paymentMethods, newData])
  }

  const getTitle = () => {
    switch (method_type) {
      case 'card':
        return 'Add Debit/Credit Card'
      case 'bank':
        return 'Add Bank '
      case 'mobile':
        return 'Add Mobile Transfer '
      case 'raast':
        return 'Add Raast  '
      case 'check':
        return 'Add Check  '
      case 'cash':
        return 'Add Cash  '
      default:
        return 'Add Payment Method'
    }
  }
  const Ref = React.useRef(null)
  const deleteCard = (cardId) => {
    showPageLoader(Ref)
    del(`/settings/billing/${cardId}/payment-method`).subscribe((res: any) => {
      hideLoader(Ref)
      if (res.response?.data) {
        showSuccess('Card deleted successfully')
        const filteredCards =
          method_type === 'card' &&
          cardPayment.filter((card) => card.stripe_payment_method_id !== cardId)
        cardPayment = filteredCards
      } else {
        hidePageLoader(Ref)
        showFailure('Something went wrong')
      }
    })
  }
  const setCardAsDefault = (cardId) => {
    post(`/settings/billing/${cardId}/default-card`, undefined).subscribe(
      (res: any) => {
        if (res.response?.data) {
          showSuccess('This card is is now default card')
        } else {
          showFailure('Something went wrong')
        }
      },
    )
  }

  React.useEffect(() => {
    setPaymentMethods(data?.payment_methods)
  }, [])
  return (
    <>
      <React.Fragment>
        <PixelCollapse
          defaultExpanded={false}
          onCollapseChange={(isExpanded) => {
            setExpanded(isExpanded)
          }}
          collapseController={
            <PixelDiv
              style={{
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                justifyContent: 'space-between',
                alignItems: 'center',
                alignContent: 'center',
                borderRadius: '5px',
                textDecoration: 'none',
                width: '98%',
                marginTop: '12px',
                padding: '10px 10px',
                marginLeft: '5px',
                background: 'transparent',
                color: '#2c2f32',
                cursor: 'pointer',
                boxShadow: '0px 0px 2px #ccc',
              }}
            >
              <PixelFlexBox
                style={{ justifyContent: 'space-between', width: '90%' }}
                id="collapse-controller"
              >
                <SectionTitle
                  style={{
                    margin: '0px',
                  }}
                >
                  {item.name}
                </SectionTitle>
              </PixelFlexBox>
              <PixelDiv
                style={{
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center',
                  justifyContent: 'flex-end',
                  height: '20px',
                  width: '10%',
                }}
                id="collapse-controller"
              >
                <PixelIcon
                  fontSize="12px"
                  color={$DCprimaryColor}
                  icon={isExpanded ? faChevronUp : faChevronDown}
                />
              </PixelDiv>
            </PixelDiv>
          }
        >
          <div>
            <PixelFlexBox
              style={{
                width: '98%',
                flexDirection: 'column',
                flexWrap: 'nowrap',
                justifyContent: 'flex-start',
                alignItems: 'flex-start',
                alignContent: 'center',
                padding: '10px 0',
                overflow: 'auto',
              }}
            >
              <PixelFlexBox justifyContent="flex-end">
                {method_type !== 'card' && (
                  <DcButton
                    onClick={() => {
                      setShowModal(true)
                    }}
                    variant="outline-primary"
                    size="sm"
                  >
                    Add New
                  </DcButton>
                )}
              </PixelFlexBox>
              <Section>
                <PixelFlexBox gap="10px" flexWrap="wrap">
                  {method_type === 'card' &&
                    cardPayment?.map((item) => {
                      return (
                        <React.Fragment key={item.id}>
                          <PixelCreditCards
                            onApply={() => {
                              pixelConfirm({
                                title: 'Delete Card',
                                message:
                                  'Are you sure? you want to delete this Card.',
                                onConfirm: () => {
                                  deleteCard(item?.stripe_payment_method_id)
                                },
                              })
                            }}
                            setCardAsDefault={() => {
                              pixelConfirm({
                                title: 'Set card as default',
                                message:
                                  'Are you sure? you want to set this Card default.',
                                onConfirm: () => {
                                  setCardAsDefault(
                                    item?.stripe_payment_method_id,
                                  )
                                },
                              })
                            }}
                            CardInfo={{
                              expiry: item?.expiry_date,
                              name: item?.account_name,
                              focused: 'name',
                              number: item.card_number.slice(-4) || '4444',
                              preview: true,
                              short_name: '',
                              //I will update this one from Pixel-base
                              card_type:
                                item?.card_type == 'Master'
                                  ? 'master'
                                  : item?.card_type == 'Visa'
                                  ? 'visa'
                                  : item?.card_type == 'Discover'
                                  ? 'discover'
                                  : item?.card_type,
                              locale: {
                                valid: 'Valid Thru',
                              },
                              placeholders: {
                                name: 'YOUR NAME HERE',
                              },
                            }}
                          />
                        </React.Fragment>
                      )
                    })}

                  {method_type === 'bank' &&
                    bankPayment.map((pm) => {
                      return (
                        <React.Fragment key={pm.id}>
                          <PaymentMethod
                            data={pm}
                            customer_id={data?.customer_id}
                            onDelete={(id) => {
                              const newPms = paymentMethods?.filter(
                                (pm: any) => pm.id !== id,
                              )
                              setPaymentMethods(newPms)
                            }}
                          ></PaymentMethod>
                        </React.Fragment>
                      )
                    })}
                </PixelFlexBox>
              </Section>
            </PixelFlexBox>
          </div>
        </PixelCollapse>
      </React.Fragment>

      {showModal && (
        <PixelModal
          title={getTitle()}
          handleClose={() => setShowModal(false)}
          show={showModal}
        >
          {showModal && (
            <AddNewPaymentMethod
              customerData={item}
              customer_id={data?.customer_id}
              method_type={item?.type}
              handleClose={(data) => {
                setShowModal(false)

                if (data) {
                  setNewData(data)
                }
              }}
            />
          )}
        </PixelModal>
      )}
    </>
  )
}

export default CollapsedPaymentOption
